// Mirrors the SQL cohort definition used in the post-auth-leak DB queries
// (auth_grant_outcome dashboards) so PostHog and Postgres breakdowns line up.
// Order matters: native (okhttp) wins over IAB, IAB wins over iOS UA matches.
export function deriveCohort(ua: string): 'native' | 'iab' | 'ios' | 'android_chrome' | 'other' {
  if (/okhttp/i.test(ua)) return 'native';
  if (/instagram|FBAN|FBAV|FBIOS/i.test(ua)) return 'iab';
  if (/iPhone|iPad/i.test(ua)) return 'ios';
  if (/Android/i.test(ua) && /Chrome/i.test(ua)) return 'android_chrome';
  return 'other';
}
